var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoubt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF877F"
    },
    d: "M72.695,499.354c-19.712,0-34.441-18.185-34.441-34.441c0-23.475,15.599-31.258,75.255-57.293 c14.14-6.187,56.243-25.011,81.382-36.506l5.862-2.671l5.641,3.106c15.778,8.687,32.469,13.09,49.604,13.09 c17.169,0,33.826-4.378,49.51-13.013l5.649-3.106l5.854,2.679c23.936,10.965,66.381,29.815,81.493,36.429 c59.639,26.027,75.238,33.809,75.238,57.284c0,16.256-14.737,34.441-34.441,34.441H72.695z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFE7E5"
    },
    cx: 256,
    cy: 226.133,
    rx: 128,
    ry: 160
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.8,
    y: 166.4,
    style: {
      fill: "#FEDEA1"
    },
    width: 51.2,
    height: 102.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 166.4,
    style: {
      fill: "#FEDEA1"
    },
    width: 51.2,
    height: 102.4
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#573A32"
    },
    d: "M25.6,464.913C25.6,489.557,48.043,512,72.687,512h366.626c24.644,0,47.087-22.443,47.087-47.087 c0-32.759-22.639-42.65-83.166-69.069c-11.452-5.009-46.362-20.48-67.627-30.054c25.737-22.673,45.107-55.91,53.854-94.703 c4.668,6.221,11.759,10.513,20.139,10.513h25.6c14.14,0,25.6-11.46,25.6-25.6v-76.8c0-14.14-11.46-25.6-25.6-25.6h-25.6 C409.6,68.77,340.83,0,256,0S102.4,68.77,102.4,153.6H76.8c-14.14,0-25.6,11.46-25.6,25.6V256c0,14.14,11.46,25.6,25.6,25.6h25.6 c7.561,0,14.174-3.422,18.867-8.627c0.777,1.101,1.468,2.219,2.389,3.285c9.233,36.548,27.998,67.814,52.565,89.463 c-22.229,10.027-56.533,25.344-67.456,30.123C48.239,422.263,25.6,432.154,25.6,464.913z M409.6,179.2h25.6V256h-25.6V179.2z  M102.4,256H76.8v-76.8h25.6V256z M128,153.6c0-70.579,57.421-128,128-128s128,57.421,128,128c0,1.041-0.282,2.014-0.307,3.055 C362.53,94.729,313.267,51.2,256,51.2S149.47,94.729,128.307,156.655C128.282,155.614,128,154.641,128,153.6z M158.626,299.426 C188.962,312.627,228.727,320,256,320c7.074,0,12.8-5.726,12.8-12.8s-5.726-12.8-12.8-12.8c-45.005,0-92.996-17.988-109.107-30.822 c-2.654-12.527-4.19-25.651-4.19-39.262c0-81.425,50.833-147.669,113.297-147.669s113.297,66.244,113.297,147.669 S318.464,371.985,256,371.985C214.588,371.985,178.389,342.775,158.626,299.426z M200.218,382.754 c17.084,9.404,35.942,14.677,55.782,14.677c19.806,0,38.639-5.214,55.689-14.601c24.337,11.145,67.046,30.106,81.69,36.514 c59.998,26.18,67.575,31.292,67.575,45.559c0,9.796-9.66,21.641-21.641,21.641H72.687c-11.981,0-21.641-11.844-21.641-21.641 c0-14.268,7.586-19.379,67.575-45.559C132.651,413.218,174.857,394.351,200.218,382.754z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubt);
export default __webpack_public_path__ + "static/media/doubt.4d885b27db282ce120a70a912d513c3f.svg";
export { ForwardRef as ReactComponent };